module.exports = __webpack_public_path__ + "img/niche-pdf-logo.f99745e5.png";